/* Contact-page SMS routing. Only a detected GB location opts into the UK sender.
 * Shopify's selected market and browser language are not physical location.
 * Keep the US links usable while detecting or if detection fails; the UK number
 * is never shown to anyone else.
 */
(() => {
  const usNumber = '+18582424442';
  const ukNumber = '+447861928878';
  const ukLabel = '+44 7861 928878';

  function useUkNumber() {
    document.querySelectorAll('[data-oem-contact-sms]').forEach((container) => {
      container.querySelectorAll('a[href^="sms:"]').forEach((link) => {
        const href = link.getAttribute('href');
        if (href === `sms:${usNumber}` || href.startsWith(`sms:${usNumber}?`)) {
          link.setAttribute('href', href.replace(usNumber, ukNumber));
        }
      });
      // Update visible numbers and the merchant-authored consent paragraph,
      // without rewriting HTML, WhatsApp destinations, or call links.
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement.closest('script, style, a[href^="tel:"], a[href*="wa.me"]')) continue;
        node.nodeValue = node.nodeValue.replace(/\+18582424442|\(858\) 242-4442/g, ukLabel);
      }
    });
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, {
    credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
  })
    .then((response) => {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    })
    .then((data) => {
      if (data?.detected_values?.country?.handle === 'GB') useUkNumber();
    })
    .catch(() => { /* US default remains. */ })
    .finally(() => clearTimeout(timeout));
})();
